<template>
  <AssetTypeVideo />
  <div
    class="container h-100 d-flex align-items-center justify-content-center z-2"
  >
    <div class="row mobile align-content-between g-0">
      <div class="col-12">
        <div class="row">
          <div
            class="col-12 ps-4 pe-4 d-flex align-items-center justify-content-end theme-header"
          >
            <router-link
              :to="{
                name: 'DashboardHome',
              }"
              class="btn-back"
            >
            </router-link>
            <p class="m-auto">{{ this.assetType }}</p>
            <a href="#" class="btn-back opacity-0"></a>
            <img src="/img/ui-theme/call.png" height="28" />
          </div>
        </div>
      </div>

      <div class="col-12 d-flex align-items-center justify-content-center z-2">
        <div class="row g-0">
          <div class="col-12">
            <template v-for="(asset, index) in assetTypes" :key="asset.Guid">
              <router-link
                :to="{
                  name: 'VideoView',
                  params: {
                    guid: this.collection.previewVideoIds,
                    collectionId: this.collection.videoLibraryId,
                  },
                }"
                class="btn-theme-menu mb-2 border-top-right"
                v-if="asset.LinkName === 'videos'"
              >
                {{ this.assetType }} Cinematic
              </router-link>
              <!-- Panorama links -->
              <router-link
                v-if="asset.LinkName === '360-tour'"
                :to="{
                  name: 'AssetViewDetail',
                  params: {
                    assetType: this.assetType,
                    viewType: '360-tour',
                    order: 0,
                  },
                }"
                :class="[
                  'btn-theme-menu',
                  'mb-2',
                  {
                    'border-bottom-left': index === assetTypes.length - 1,
                    'border-top-right': index === 0,
                  },
                ]"
              >
                <!-- <img :src="theme.panoramasIcon" :alt="asset.ObjectName" class="me-3"> -->
                {{ asset.ObjectName }}
              </router-link>

              <router-link
                v-if="asset.LinkName === 'balcony-views'"
                :to="{
                  name: 'AssetViewDetail',
                  params: {
                    assetType: this.assetType,
                    viewType: 'balcony-views',
                    order: 0,
                  },
                }"
                :class="[
                  'btn-theme-menu',
                  'mb-2',
                  {
                    'border-bottom-left': index === assetTypes.length - 1,
                    'border-top-right': index === 0,
                  },
                ]"
              >
                <!-- <img :src="theme.panoramasIcon" :alt="asset.ObjectName" class="me-3"> -->
                {{ asset.ObjectName }}
              </router-link>

              <!-- Renders links -->
              <router-link
                v-if="
                  asset.LinkName === 'renders' || asset.LinkName === 'range'
                "
                :to="{
                  name: asset.ComponentName,
                  params: {
                    assetType: this.assetType,
                    viewType: asset.LinkName,
                  },
                }"
                :class="[
                  'btn-theme-menu',
                  'mb-2',
                  {
                    'border-bottom-left': index === assetTypes.length - 1,
                    'border-top-right': index === 0,
                  },
                ]"
              >
                <!-- <img :src="theme.rendersIcon" :alt="asset.ObjectName" class="me-3"> -->
                {{ asset.ObjectName }}
              </router-link>

              <!-- Floorplans links -->
              <router-link
                v-if="asset.LinkName === 'floorplans'"
                :to="{
                  name: asset.ComponentName,
                  params: {
                    assetType: this.assetType,
                    viewType: asset.LinkName,
                  },
                }"
                :class="[
                  'btn-theme-menu',
                  'mb-2',
                  {
                    'border-bottom-left': index === assetTypes.length - 1,
                    'border-top-right': index === 0,
                  },
                ]"
              >
                <!-- <img :src="theme.floorplansIcon" :alt="asset.ObjectName" class="me-3"> -->
                {{ asset.ObjectName }}
              </router-link>
            </template>
          </div>
        </div>
      </div>

      <TypeBotNav />
    </div>
  </div>
  <OffCanvas />
</template>

<script>
import AssetTypeVideo from "@/components/AssetTypeVideo.vue";

import ViewTopNav from "@/components/ViewTopNav.vue";
import TypeBotNav from "@/components/TypeBotNav.vue";
import OffCanvas from "@/components/OffCanvas.vue";
import global from "../global";
import BunnyNetService from "@/services/BunnyNetService.js";
import { unslugify } from "unslugify";
import sortArray from "sort-array";

export default {
  name: "AssetType",
  props: ["assetType"],
  components: {
    AssetTypeVideo,
    ViewTopNav,
    TypeBotNav,
    OffCanvas,
  },
  data() {
    return {
      assetTypes: null,
      collection: null,
      componentName: "AssetView",
      folderStructure: encodeURIComponent(
        this.theme.devFolder + "/assets/" + this.assetType + "/"
      ),
      assetOrder: null,
    };
  },
  mounted() {
    const tooltipTriggerList = [].slice.call(
      document.querySelectorAll('[data-bs-toggle="tooltip"]')
    );
    tooltipTriggerList.forEach(function (tooltipTriggerEl) {
      new bootstrap.Tooltip(tooltipTriggerEl);
    });
  },
  created() {
    BunnyNetService.getFolders(this.folderStructure)
      .then((response) => {
        // Remap array
        const menuItems = response.data.map((item) => {
          return {
            Guid: item.Guid,
            ObjectName: unslugify(item.ObjectName),
            LinkName: item.ObjectName,
            ComponentName: this.componentName,
            Path: item.Path,
            IsDirectory: item.IsDirectory,
            StorageZoneName: item.StorageZoneName,
          };
        });

        // Assign type menu array
        this.assetOrder = this.theme.type1MenuOrder;

        // Sort array
        const customMenu = sortArray(menuItems, {
          by: ["LinkName"],
          order: "LinkName",
          customOrders: {
            LinkName: this.theme.typeAMenuOrder,
          },
        });
        this.assetTypes = customMenu;
      })
      .catch((error) => {
        console.log(error);
      }),
      // api call get video collection details
      BunnyNetService.getCollections(this.theme.videoLibraryId, this.assetType)
        .then((response) => {
          console.log(response);
          this.collection = response.data[0];
        })
        .catch((error) => {
          console.log(error);
        });
  },
  setup() {
    // load global config
    const { theme } = global;

    return {
      theme,
    };
  },
};
</script>
